/**
 * Ermes (ContrattiSmart), pagina Allegati: in alto, per ogni sito (POD/PDR), le operazioni da richiedere insieme al
 * contratto ("Aggiungi allegati per il sito ..."). Vanno sempre chieste all'operatore: anche più di una, oppure
 * "Nessuna". I codici si salvano nei dati portale (`OPERAZIONI_POD` / `OPERAZIONI_PDR`) separati da virgola; le
 * etichette sono quelle del portale, che lo script della bozza usa per trovare la voce da aggiungere.
 */
export const OPERAZIONE_NESSUNA = 'NESSUNA'

export interface ErmesOperazione { code: string; label: string }

export const ERMES_OPERAZIONI_LUCE: ErmesOperazione[] = [
  { code: 'VOLTURA_ORDINARIA', label: 'Voltura Ordinaria' },
  { code: 'VOLTURA_CONTESTUALE', label: 'Voltura Contestuale' },
  { code: 'SUBENTRO', label: 'Richiesta di Subentro / Preposato (riattivazione)' },
  { code: 'NUOVA_ATTIVAZIONE', label: 'Nuova Attivazione' },
  { code: 'NUOVA_ATTIVAZIONE_TEMPORANEA', label: 'Nuova Attivazione Temporanea' },
  { code: 'AUMENTO_POTENZA', label: 'Aumento Potenza' },
  { code: 'DIMINUZIONE_POTENZA', label: 'Diminuzione Potenza' },
]

/** Gas: stesse operazioni senza quelle sulla potenza (elenco del portale da confermare alla prima pratica gas). */
export const ERMES_OPERAZIONI_GAS: ErmesOperazione[] = ERMES_OPERAZIONI_LUCE.filter(o => !o.code.endsWith('_POTENZA'))

/** Codici scelti (senza "Nessuna"). */
export function operazioniScelte(value: string | undefined): string[] {
  return String(value ?? '').split(',').map(s => s.trim()).filter(s => s && s !== OPERAZIONE_NESSUNA)
}

/** Una risposta c'è stata: almeno un'operazione oppure "Nessuna". */
export function operazioniRisposte(value: string | undefined): boolean {
  return String(value ?? '').split(',').some(s => s.trim())
}

/** Aggiunge o toglie un codice; "Nessuna" esclude tutte le altre. */
export function toggleOperazione(value: string | undefined, code: string, on: boolean): string {
  const cur = String(value ?? '').split(',').map(s => s.trim()).filter(Boolean)
  if (!on) return cur.filter(c => c !== code).join(',')
  if (code === OPERAZIONE_NESSUNA) return OPERAZIONE_NESSUNA
  return [...cur.filter(c => c !== OPERAZIONE_NESSUNA && c !== code), code].join(',')
}

/** Riattivazione (subentro): la bolletta/fattura non è obbligatoria per il caricamento su Ermes. */
export function isRiattivazione(v: Record<string, string | undefined>): boolean {
  return v['TIPO_FORNITURA_POD'] === 'RIATTIVAZIONE' || v['TIPO_FORNITURA_PDR'] === 'RIATTIVAZIONE'
    || operazioniScelte(v['OPERAZIONI_POD']).includes('SUBENTRO') || operazioniScelte(v['OPERAZIONI_PDR']).includes('SUBENTRO')
}
